import { NewtopiaBottomCards, NewtopiaMarketCard, NewtopiaTopCards } from './NewtopiaCards';

export const ForSmallDesktops = () => {
	return (
		<div className='newtopiaSmallScreen'>
			<div className='cardContainer'>
				<NewtopiaTopCards className='topCardContainer' />
				<NewtopiaMarketCard wrapperClassName='midCardContainer' cardClassName='midCard' />
				<NewtopiaBottomCards className='bottomCardContainer' />
				<div className='newtopiawave'></div>
			</div>
			<div className='footer'></div>
		</div>
	);
};
